export class SearchPreference {
    constructor(type: string, value: string | boolean) {
        this.Type = type;
        this.Value = value;
    }
    Type: string;
    Value: string | boolean;
}
